export const TextPlaceholder = ({
  height,
  width,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <p
      className={'placeholder-glow ' + (isNaN(width) ? 'w-100' : '')}
      style={{
        width,
        marginBottom: 4,
      }}
    >
      <span
        className="placeholder w-100"
        style={{
          height,
        }}
      ></span>
    </p>
  );
};
